module.exports = __webpack_public_path__ + "img/logo_login.228eb9ca.png";